import { createFileRoute } from '@tanstack/react-router'
import ChatbotPage from '@/views/chatbot 17-35-23-799'

export const Route = createFileRoute('/_authenticated/chatbot')({
  component: ChatbotPage,
})
